import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  pageDescription: {
    marginBottom: theme.spacing(2),
  },
  searchBarOuterWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  searchInputCell: {
    maxWidth: 420,
    flex: '1 1 420px',
  },
  searchBarRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
    },
  },
  tableScrollWrapper: {
    overflowX: 'auto',
  },
  stackedCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  mutedText: {
    color: theme.palette.text.secondary,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  requestTypes: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  requestTypeChip: {
    maxWidth: 160,
  },
  tableLink: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  actionsCell: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  statusCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  detailGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  detailField: {
    display: 'grid',
    gap: theme.spacing(0.5),
  },
  detailLabel: {
    color: theme.palette.text.secondary,
  },
  detailValue: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  requestTypeCard: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  requestTypeList: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  emptyState: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
}));

export default useStyles;
